import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { PatientNotesScreen } from 'screens/patient';

export default withPermissions(PatientNotesScreen, [
  GroupSecurity.ClinicalImpressionRead,
]);
